<template>
	<div class="Confirmation_view">
		<Loading v-if="loading" :large="true" />

		<div v-else class="Confirmation_view__content">
			<!-- Thank you info -->
			<h1 class="colorWhite">{{ $t('confirmation.heading') }}</h1>
			<h2 class="h3 colorWhite">
				{{ $t('confirmation.bookingNumber') }}:
				<strong>{{ bookingId }}</strong>
			</h2>

			<br />

			<p v-if="isLoggedIn()" class="colorWhite">
				{{ $t('confirmation.bodyText1') }} {{ userEmail }}
				<span v-html="$t('confirmation.bodyText2')"></span>
			</p>
			<p v-else class="colorWhite">
				<span v-html="$t('confirmation.bodyTextAnonymous')"></span>
			</p>

			<br />

			<router-link
				v-if="isLoggedIn()"
				:to="{
					name: 'booking',
					params: { id: bookingId }
				}"
			>
				<Button>
					{{ $t('confirmation.buttonText') }}
				</Button>
			</router-link>

			<br />
			<br />
			<br />

			<!-- Survey -->
			<h3 class="h2 colorWhite">{{ $t('confirmation.surveyHeading') }}</h3>
			<p class="colorWhite">
				{{ $t('confirmation.surveyBodyText') }}
			</p>
			<br />
			<a
				href="https://response.questback.com/aqanalysab/klappenbookning"
				target="_blank"
			>
				<Button>
					{{ $t('confirmation.surveyButtonText') }}
				</Button>
			</a>
		</div>
	</div>
</template>

<script>
import store from '../vueX/store'
import Loading from '../components/atoms/Loading'
import Button from '../components/atoms/Button'

export default {
	name: 'Confirmation',
	components: {
		Loading,
		Button
	},
	data() {
		return {
			loading: true
		}
	},
	computed: {
		bookingId() {
			return this.$route.query.resvid ? this.$route.query.resvid : ''
		},
		userEmail() {
			return store.state.user.email
		}
	},
	created() {
		store.dispatch('GET_BOOKING', this.bookingId).then(success => {
			if (success) {
				store.dispatch('GTM_PUSH_CONFIRMATION', success)
			}
			this.loading = false
		})
	},
	methods: {
		isLoggedIn() {
			return store.state.user != null
		}
	}
}
</script>

<style lang="scss">
.Confirmation_view {
	min-height: calc(100vh - 100px);
	padding-top: 40px;
	background: linear-gradient(
		0deg,
		rgba(97, 107, 129, 1) 0%,
		rgba(179, 188, 208, 1) 100%
	);
	text-align: center;

	a {
		color: white;
		text-decoration: underline;
	}

	> * {
		margin-left: auto;
		margin-right: auto;
	}

	&__content {
		max-width: 590px;
	}

	@include for-tablet-portrait-up {
		padding-top: 100px;
		min-height: calc(100vh - 160px);
	}
}
</style>
